// import axios from 'axios'
import { clearBasket } from './basket';
var waitMessege = document.createElement("div");
waitMessege.classList.add("wait__loader");
waitMessege.innerHTML = "<div class=\"preloader-ring\"></div>";
export function sendData() {
  $('.barba-container').appendChild(waitMessege);
  var infoData = "";
  window.gParts.forEach(function (item) {
    infoData = "".concat(infoData).concat(item.info, " \u043D\u0430 ").concat(item.name, " ").concat(item.price, "\u20BD\n");
  });
  axios.post("/send-lid", {
    user_phone: window.gPhone,
    summa: window.gPrice,
    info: infoData,
    ip: window.ip
  }).then(function (r) {
    waitMessege.remove();
    if (typeof ym === 'function') {
      ym(49104928, 'reachGoal', 'malert__order');
      ga("send", "event", "zayavka-open", "submit");
      // ga('config', 'AW-741774639');
      // fbq('track', 'Purchase', {currency: "RUB", value: 100.00});
      // fbq(`track`, `SubmitApplication`);
    }
    cPush.show({
      title: "Спасибо за заявку!",
      text: "Скоро мы с вами свяжемся."
    });
    sendToCrm(window.gPhone);
    setTimeout(function () {
      return clearBasket();
    }, 1000);
  })["catch"](function (e) {
    // console.log(error);
    cPush.show({
      title: "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430!",
      text: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430: ".concat(e)
    });
    waitMessege.remove();
  });
}
export function sendToCrm(phone) {
  var summa = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var model = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var info = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  if (localStorage.getItem('parts')) {
    info = [];
    summa = 0;
    var arr = JSON.parse(localStorage.getItem('parts'));
    arr.forEach(function (item) {
      model = item.name;
      info.push(item.info);
      summa = summa + +item.price;
    });
    info = info.join(', ');
  }
  axios.post("https://crmius.ru/api/push-order", {
    mail: 'imalets',
    push: "true",
    phone: phone,
    name: "\u0421\u0430\u0439\u0442",
    model: model,
    adress: window.ip,
    usluga: info,
    price_part: 0,
    get_money: summa,
    ready: 0,
    info: ""
  });
}
export function ZayavkaO() {
  $$(".form__submit").forEach(function (element) {
    element.onsubmit = function (e) {
      e.preventDefault();
      var value = element.querySelector(".call__input").value;
      if (value.length >= 17 || value.length === 19) {
        PushMsg($('.barba-container'));
        sendToCrm(value);
      } else shakeForm(element, element.querySelector(".call__input"));
      function PushMsg(Item) {
        Item.appendChild(waitMessege);
        axios.post("/send-lid", {
          user_phone: value,
          ip: window.ip
        }).then(function (r) {
          cPush.show({
            title: "Спасибо за заявку!",
            text: "Скоро мы с вами свяжемся."
          });
          waitMessege.remove();
          if (typeof ym === "function") {
            ym(49104928, "reachGoal", "open__order");
            ga("send", "event", "zayavka-open", "submit");
            // fbq("track", "Purchase");
            // VK.Goal('purchase')
          }
          element.querySelector(".call__input").value = "";
        })["catch"](function (e) {
          cPush.show({
            title: "\u0417\u0430\u044F\u0432\u043A\u0430 \u043D\u0435 \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430!",
            text: "\u041F\u0440\u0438\u0447\u0438\u043D\u0430: ".concat(e)
          });
          waitMessege.remove();
        });
      }
    };
  });
}